import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';
import { ChangeLogSocialsComponent } from './change-log-socials.component';

@NgModule({
  declarations: [ChangeLogSocialsComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogSocialsComponent],
})
export class ChangeLogSocialsModule {}
